module.exports = __webpack_public_path__ + "img/web_2_2x.d6dc3450.png";